module.exports = __webpack_public_path__ + "static/media/01B.c26f9695.png";